import {FcGoogle} from 'react-icons/fc'
import {FaTwitter, FaInstagram, FaYoutube} from 'react-icons/fa'

import './index.css'
import HeaderContext from '../../context/HeaderContext'

const Footer = () => (
  <HeaderContext.Consumer>
    {value => {
      const {isDarkTheme} = value

      const footerDarkText = isDarkTheme ? 'footer-dark-text' : ''

      return (
        <div className="footer-container animate__animated animate__bounceInUp">
          <p className={`contact-us-text ${footerDarkText}`}>Contact us</p>
          <div className="icons-container">
            <button type="button" className="footer-icon-button">
              <a
                href="mailto: abhiram8034@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <FcGoogle className={`footer-icon ${footerDarkText}`} />
              </a>
            </button>
            <button type="button" className="footer-icon-button">
              <a
                href="https://twitter.com/mavy_8034"
                target="_blank"
                rel="noreferrer"
              >
                <FaTwitter
                  className={`footer-icon ${footerDarkText} twitter-icon`}
                />
              </a>
            </button>
            <button type="button" className="footer-icon-button">
              <a
                href="https://www.instagram.com/mavy__8034_/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram
                  className={`footer-icon ${footerDarkText} instagram-icon`}
                />
              </a>
            </button>
            <button type="button" className="footer-icon-button">
              <a
                href="https://www.youtube.com/channel/UCA4R2DaFXE_GCcKj5qdJOGQ"
                target="_blank"
                rel="noreferrer"
              >
                <FaYoutube
                  className={`footer-icon ${footerDarkText} youtube-icon`}
                />
              </a>
            </button>
          </div>
        </div>
      )
    }}
  </HeaderContext.Consumer>
)

export default Footer
